import { render } from "./ExpertRichGuide.vue?vue&type=template&id=63fb4e51&scoped=true"
import script from "./ExpertRichGuide.vue?vue&type=script&lang=js"
export * from "./ExpertRichGuide.vue?vue&type=script&lang=js"

import "./ExpertRichGuide.vue?vue&type=style&index=0&id=63fb4e51&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63fb4e51"]])

export default __exports__